export const ANALYTICS_TABS = [
  {
    slug: "batch-capacity",
    label: "Batch Capacity",
    path: "/admin/analytics/batch-capacity",
    breadcrumb: "Batch Capacity",
  },
  {
    slug: "payment-overdue",
    label: "Fee Alerts",
    path: "/admin/analytics/payment-overdue",
    breadcrumb: "Fee Alerts",
  },
  {
    slug: "academic-support",
    label: "Student Performance",
    path: "/admin/analytics/academic-support",
    breadcrumb: "Student Performance",
  },
  {
    slug: "target-schools",
    label: "Target Schools",
    path: "/admin/analytics/target-schools",
    breadcrumb: "Target Schools",
  },
  {
    slug: "revision-planning",
    label: "Revision Analytics",
    path: "/admin/analytics/revision-planning",
    breadcrumb: "Revision Analytics",
  },
  {
    slug: "geographic",
    label: "Geographical Insights",
    path: "/admin/analytics/geographic",
    breadcrumb: "Geographical Insights",
  },
  {
    slug: "app-usage",
    label: "App Engagement",
    path: "/admin/analytics/app-usage",
    breadcrumb: "App Engagement",
  },
  {
    slug: "notifications",
    label: "Notifications",
    path: "/admin/analytics/notifications",
    breadcrumb: "Notifications",
  },
];

export function analyticsTabByPath(pathname) {
  return ANALYTICS_TABS.find((t) => pathname === t.path || pathname.startsWith(`${t.path}/`))
    || ANALYTICS_TABS[0];
}
